//
// Copyright 2021 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/echo/metadata.proto (package dxos.echo.metadata, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Invitation, SpaceState } from "../client/invitation_pb.js";
import { file_dxos_client_invitation } from "../client/invitation_pb.js";
import type { TimeframeVector } from "./timeframe_pb.js";
import { file_dxos_echo_timeframe } from "./timeframe_pb.js";
import type { Credential, ProfileDocument } from "../halo/credentials_pb.js";
import { file_dxos_halo_credentials } from "../halo/credentials_pb.js";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/echo/metadata.proto.
 */
export const file_dxos_echo_metadata: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_dxos_client_invitation, file_dxos_echo_timeframe, file_dxos_halo_credentials, file_dxos_keys]);

/**
 * / Main metadata record.
 *
 * @generated from message dxos.echo.metadata.EchoMetadata
 */
export type EchoMetadata = Message<"dxos.echo.metadata.EchoMetadata"> & {
  /**
   * *
   * Version number that is incremented every time there's a breaking change to the storage schema.
   * This is used to detect if the storage schema has changed since the last time the client was run.
   * Loading data from a different version will might result in an error.
   *
   * @generated from field: int32 version = 1;
   */
  version: number;

  /**
   * @generated from field: google.protobuf.Timestamp created = 2;
   */
  created?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 3;
   */
  updated?: Timestamp;

  /**
   * TODO(dmaretskyi): Store the device key associated with the identity.
   *
   * @generated from field: optional dxos.echo.metadata.IdentityRecord identity = 10;
   */
  identity?: IdentityRecord;

  /**
   * / List of the data spaces.
   *
   * @generated from field: repeated dxos.echo.metadata.SpaceMetadata spaces = 11;
   */
  spaces: SpaceMetadata[];

  /**
   * TODO(burdon): Circular dep.
   *
   * @generated from field: repeated dxos.client.services.Invitation invitations = 12;
   */
  invitations: Invitation[];

  /**
   * / Keys of spaces that have been tombstoned (soft-deleted). Survives restart; prevents re-acceptance.
   *
   * @generated from field: repeated dxos.keys.PublicKey deleted_spaces = 13;
   */
  deletedSpaces: PublicKey[];
};

/**
 * Describes the message dxos.echo.metadata.EchoMetadata.
 * Use `create(EchoMetadataSchema)` to create a new message.
 */
export const EchoMetadataSchema: GenMessage<EchoMetadata> = /*@__PURE__*/
  messageDesc(file_dxos_echo_metadata, 0);

/**
 * / Per-space metadata. Frequent updates. Keep small.
 *
 * @generated from message dxos.echo.metadata.SmallSpaceMetadata
 */
export type SmallSpaceMetadata = Message<"dxos.echo.metadata.SmallSpaceMetadata"> & {
};

/**
 * Describes the message dxos.echo.metadata.SmallSpaceMetadata.
 * Use `create(SmallSpaceMetadataSchema)` to create a new message.
 */
export const SmallSpaceMetadataSchema: GenMessage<SmallSpaceMetadata> = /*@__PURE__*/
  messageDesc(file_dxos_echo_metadata, 1);

/**
 * / Per-space metadata. Infrequent updates.
 *
 * @generated from message dxos.echo.metadata.LargeSpaceMetadata
 */
export type LargeSpaceMetadata = Message<"dxos.echo.metadata.LargeSpaceMetadata"> & {
  /**
   * @generated from field: optional dxos.echo.metadata.ControlPipelineSnapshot control_pipeline_snapshot = 1;
   */
  controlPipelineSnapshot?: ControlPipelineSnapshot;
};

/**
 * Describes the message dxos.echo.metadata.LargeSpaceMetadata.
 * Use `create(LargeSpaceMetadataSchema)` to create a new message.
 */
export const LargeSpaceMetadataSchema: GenMessage<LargeSpaceMetadata> = /*@__PURE__*/
  messageDesc(file_dxos_echo_metadata, 2);

/**
 * TODO(dmaretskyi): Cleanup numbering.
 *
 * @generated from message dxos.echo.metadata.SpaceMetadata
 */
export type SpaceMetadata = Message<"dxos.echo.metadata.SpaceMetadata"> & {
  /**
   * / Space key.
   *
   * @generated from field: dxos.keys.PublicKey key = 1;
   */
  key?: PublicKey;

  /**
   * / Space id — the primary identifier for the space.
   * / Derived from the space genesis key, and carried so readers do not have to re-derive it.
   *
   * @generated from field: optional string space_id = 13;
   */
  spaceId?: string;

  /**
   * / Immutable tags assigned at space creation time.
   *
   * @generated from field: repeated string tags = 12;
   */
  tags: string[];

  /**
   * / ACTIVE, INACTIVE, etc.
   *
   * @generated from field: optional dxos.client.services.SpaceState state = 10;
   */
  state?: SpaceState;

  /**
   * @generated from field: optional dxos.keys.PublicKey genesis_feed_key = 6;
   */
  genesisFeedKey?: PublicKey;

  /**
   * / Key of the writable control feed.
   *
   * @generated from field: optional dxos.keys.PublicKey control_feed_key = 4;
   */
  controlFeedKey?: PublicKey;

  /**
   * / List of all feed associated with the space.
   *
   * @generated from field: repeated dxos.keys.PublicKey feed_keys = 2;
   */
  feedKeys: PublicKey[];

  /**
   * / Key of the writable data feed.
   *
   * @generated from field: optional dxos.keys.PublicKey data_feed_key = 3;
   */
  dataFeedKey?: PublicKey;

  /**
   * Latest control timeframe reached while processing space messages.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector control_timeframe = 8;
   */
  controlTimeframe?: TimeframeVector;

  /**
   * Latest data timeframe reached while processing space messages.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector data_timeframe = 5;
   */
  dataTimeframe?: TimeframeVector;

  /**
   * @generated from field: optional dxos.echo.metadata.EdgeReplicationSetting edge_replication = 11;
   */
  edgeReplication?: EdgeReplicationSetting;
};

/**
 * Describes the message dxos.echo.metadata.SpaceMetadata.
 * Use `create(SpaceMetadataSchema)` to create a new message.
 */
export const SpaceMetadataSchema: GenMessage<SpaceMetadata> = /*@__PURE__*/
  messageDesc(file_dxos_echo_metadata, 3);

/**
 * @generated from message dxos.echo.metadata.ControlPipelineSnapshot
 */
export type ControlPipelineSnapshot = Message<"dxos.echo.metadata.ControlPipelineSnapshot"> & {
  /**
   * / Timeframe of the last message included in the snapshot.
   *
   * @generated from field: dxos.echo.timeframe.TimeframeVector timeframe = 1;
   */
  timeframe?: TimeframeVector;

  /**
   * @generated from field: repeated dxos.echo.metadata.ControlPipelineSnapshot.ControlMessage messages = 2;
   */
  messages: ControlPipelineSnapshot_ControlMessage[];
};

/**
 * Describes the message dxos.echo.metadata.ControlPipelineSnapshot.
 * Use `create(ControlPipelineSnapshotSchema)` to create a new message.
 */
export const ControlPipelineSnapshotSchema: GenMessage<ControlPipelineSnapshot> = /*@__PURE__*/
  messageDesc(file_dxos_echo_metadata, 4);

/**
 * @generated from message dxos.echo.metadata.ControlPipelineSnapshot.ControlMessage
 */
export type ControlPipelineSnapshot_ControlMessage = Message<"dxos.echo.metadata.ControlPipelineSnapshot.ControlMessage"> & {
  /**
   * @generated from field: dxos.keys.PublicKey feed_key = 1;
   */
  feedKey?: PublicKey;

  /**
   * @generated from field: dxos.halo.credentials.Credential credential = 2;
   */
  credential?: Credential;
};

/**
 * Describes the message dxos.echo.metadata.ControlPipelineSnapshot.ControlMessage.
 * Use `create(ControlPipelineSnapshot_ControlMessageSchema)` to create a new message.
 */
export const ControlPipelineSnapshot_ControlMessageSchema: GenMessage<ControlPipelineSnapshot_ControlMessage> = /*@__PURE__*/
  messageDesc(file_dxos_echo_metadata, 4, 0);

/**
 * / Information needed to bootstrap an Identity.
 *
 * @generated from message dxos.echo.metadata.IdentityRecord
 */
export type IdentityRecord = Message<"dxos.echo.metadata.IdentityRecord"> & {
  /**
   * @generated from field: dxos.keys.PublicKey identity_key = 1;
   */
  identityKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey device_key = 2;
   */
  deviceKey?: PublicKey;

  /**
   * @generated from field: dxos.echo.metadata.SpaceMetadata halo_space = 3;
   */
  haloSpace?: SpaceMetadata;

  /**
   * / Public profile information.
   * / TODO(burdon): Not yet implemented. Must be null.
   *
   * @generated from field: optional dxos.echo.metadata.SpaceMetadata profile_space = 4;
   */
  profileSpace?: SpaceMetadata;

  /**
   * / Cached profile.
   *
   * @generated from field: optional dxos.halo.credentials.ProfileDocument profile = 5;
   */
  profile?: ProfileDocument;
};

/**
 * Describes the message dxos.echo.metadata.IdentityRecord.
 * Use `create(IdentityRecordSchema)` to create a new message.
 */
export const IdentityRecordSchema: GenMessage<IdentityRecord> = /*@__PURE__*/
  messageDesc(file_dxos_echo_metadata, 5);

/**
 * @generated from enum dxos.echo.metadata.EdgeReplicationSetting
 */
export enum EdgeReplicationSetting {
  /**
   * @generated from enum value: DISABLED = 0;
   */
  DISABLED = 0,

  /**
   * @generated from enum value: ENABLED = 1;
   */
  ENABLED = 1,
}

/**
 * Describes the enum dxos.echo.metadata.EdgeReplicationSetting.
 */
export const EdgeReplicationSettingSchema: GenEnum<EdgeReplicationSetting> = /*@__PURE__*/
  enumDesc(file_dxos_echo_metadata, 0);

